import { ActionBeginEventArgs, InPlaceEditorModel } from '@syncfusion/ej2-inplace-editor';
import { TextBox, TextBoxModel } from '@syncfusion/ej2-inputs';

import { EditableClientProps } from '@/shared/types/editable';

import { controlModel } from '@/front/editable/control';
import { input } from '@/front/editable/input';
import { addValidation, getEditor, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';

export const initTextBox = (p: EditableClientProps, e: HTMLElement) => {
  const textBox = new TextBox({
    ...textBoxModel(p),
    change: change(e),
  });

  textBox.appendTo(input(p, e));

  setControl(p.id, textBox);

  addValidation(p, e);
};

export const textBoxModel = (p: EditableClientProps, o?: { resetHeightOnBlur: boolean }): TextBoxModel => {
  const resetHeight = (args: any) => {
    args.event.currentTarget.style.height = 100 + 'px';
  };

  const growHeight = (args: any) => {
    resetHeight(args);
    args.event.currentTarget.style.height = args.event.currentTarget.scrollHeight + 'px';
  };

  return {
    ...controlModel(p),
    placeholder: p.placeholder ?? (p.defaultValue as string),
    showClearButton: false,
    autocomplete: 'off',
    ...(p.multiline && {
      multiline: true,
      focus: growHeight,
      input: growHeight,
      ...(o?.resetHeightOnBlur ? { blur: resetHeight } : {}),
    }),
  };
};

export const textEditorModel = (p: EditableClientProps): Partial<InPlaceEditorModel> => ({
  beginEdit: () => {
    setTimeout(() => {
      const input = getEditor(p.id).element.querySelector('.e-input') as HTMLInputElement | HTMLTextAreaElement;
      input.focus();
      if (p.multiline) {
        // Move cursor to start if textarea to avoid jumping to end (e.g. notes)
        input.setSelectionRange(0, 0);
        input.scrollTop = 0;
      }
    }, 1);
  },
  submitClick: () => {
    const value = getEditor(p.id).value;

    if (typeof value === 'string') {
      getEditor(p.id).value = value.trim() || '';
    }
  },
  actionBegin: (args: ActionBeginEventArgs) => {
    const value = args.data.value;

    if (typeof value === 'string') {
      args.data.value = value.trim() || '';
    }
  },
});
